
import { Component, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { MR } from "@/store/modules";
import { CurrencyFormatMixin } from "@/mixins";
import { MRSummaryMixin } from "../../mixin/MRSummaryMixin";
import { axiosProvider } from "@/store/provider";

@Component({
  components: {},
})
export class MRSummaryPrint extends mixins(MRSummaryMixin) {
  @Prop(MR)
  private record!: MR;

  private totalMaterials: number | null = null;

  async mounted() {
    if (this.record && this.record.id) {
      try {
        const response = await axiosProvider('mr').get<number>(`total-materials/${this.record.id}`);
        this.totalMaterials = response.data;
      } catch (error) {
        console.error('Error fetching total materials:', error);
        this.totalMaterials = null;
      }
    }
  }

  get total(): string {
    // return '0';
    return this.formatLocaleCurrency(
      this.record.price ? this.record.price * 1.05 : 0
    );
  }

  formatHours(record: MR) {
    const h = +(record.hours || 0);
    if (isNaN(h)) {
      return 0;
    }
    return h / 4;
  }

  get totalRemaining() {
    if (!this.record) {
      return 0;
    }
    const t = this.calcTotalApprovePayment(this.record);
    return this.formatLocaleCurrency((this.record.price || 0) * 1.05 - t);
  }
}

export default MRSummaryPrint;
